module.exports = __webpack_public_path__ + "background.5e71b7d4a7f83b512afb.png";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/img/beasley/background.png
// module id = ../../../../../src/assets/img/beasley/background.png
// module chunks = main